const API = {
    provices: '/system/district/provices',
    cities: '/system/district/cities/',
    counties: '/system/district/counties/',
    detail: '/system/district/detail/',

    /*获取一级、二级、三级类目   第一级传0.第二，三级传上一级id */
    getListLevelBackendCategory: '/goods/category/getLevelCategory/',
    /*删除类目*/
    cancelStoreCategory: '/goods/category/cancelStoreCategory',


    login: '/base/system/user/login',
    /*登录*/
    getMerchantInfoStateByLoginName: "/merchant/merchantEnter/getMerchantInfoStateByLoginName",
    /*查询*/
    insertMerchantQualification: "/merchant/merchantEnter/insertMerchantQualification",
    /*基本信息添加*/
    updateMerchantQualificationById: "/merchant/merchantEnter/updateMerchantQualificationById",
    /*基本信息修改*/
    getMerchantInfoByLoginName: "/merchant/merchantEnter/getMerchantInfoByLoginName",
    /*基本信息回显*/
    insertMerchantAccount: "/merchant/merchantEnter/insertMerchantAccount",
    /*经营信息添加*/
    updateMerchantManageInfoById: "/merchant/merchantEnter/updateMerchantManageInfoById",
    /*经营信息修改*/
    getMercahntManageInfoByLoginName: "/merchant/merchantEnter/getMercahntManageInfoByLoginName",
    /*经营信息回显*/
    insertStoreInfo: "/merchant/merchantEnter/insertStoreInfo",
    /*经营范围添加*/
    getMerchantTypeByLoginName: "/merchant/merchantEnter/getMerchantTypeByLoginName",
    /*经营范围回显*/
    insertPayImage: "/merchant/merchantEnter/insertPayImage",
    /*上传缴费凭证*/
    getCostInfoByIds: "/merchant/merchantEnter/getCostInfoByIds",
    /*缴费回显*/
    selectMerchantauditLogDetail: "/merchant/merchantEnter/selectMerchantauditLogDetail/",
    /*审核不通过回显*/
    selectMerchantauditLog: "/merchant/merchantEnter/selectMerchantauditLog",
    /*审核记录*/

    saveStoreCategory: '/goods/category/saveStoreCategory', //添加类目
    getStoreCategory: '/goods/category/getStoreCategory', //类目回显
}
export default API


// WEBPACK FOOTER //
// ./src/api/fetch_api.js